import * as React from "react";

interface PdfDocumentIllustrationProps {
  className?: string;
}

const PdfDocumentIllustration: React.FC<PdfDocumentIllustrationProps> = ({
  className,
}) => {
  return (
    <svg
      width="76"
      height="90"
      viewBox="0 0 76 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M67.9685 90H8.03149C3.59582 90 0 86.4042 0 81.9685V8.03149C0 3.59582 3.59582 0 8.0315 0H49L76 27V81.9685C76 86.4042 72.4042 90 67.9685 90Z"
        className="fill-background"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49 0H8.0315C3.59582 0 0 3.59582 0 8.03149V81.9685C0 86.4042 3.59582 90 8.03149 90H67.9685C72.4042 90 76 86.4042 76 81.9685V27L49 0ZM70.2574 25.5L50.5 5.74264V18.9685C50.5 22.5758 53.4243 25.5 57.0315 25.5H70.2574ZM47.5 3H8.0315C5.25268 3 3 5.25268 3 8.03149V81.9685C3 84.7473 5.25268 87 8.03149 87H67.9685C70.7473 87 73 84.7473 73 81.9685V28.5H57.0315C51.7674 28.5 47.5 24.2326 47.5 18.9685V3Z"
        className="fill-gray-2"
      />
      <path
        d="M52.5894 58.532C49.7199 58.532 46.1287 59.0473 44.954 59.2286C40.0915 54.0007 38.708 51.0291 38.3969 50.2368C38.8186 49.1213 40.2858 44.8835 40.4943 39.4408C40.5972 36.7158 40.038 34.6796 38.8321 33.3889C37.6282 32.1002 36.171 32 35.7532 32C34.288 32 31.8301 32.7628 31.8301 37.8709C31.8301 42.303 33.8372 47.006 34.392 48.2212C31.4689 56.9839 28.3307 62.9826 27.6643 64.2162C15.9185 68.7693 15 73.1716 15 74.4193C15 76.6614 16.5509 78 19.1488 78C25.4604 78 31.2202 67.0902 32.1726 65.1958C36.6554 63.3568 42.6553 62.2178 44.1806 61.946C48.5556 66.2368 53.6155 67.3817 55.7167 67.3817C57.2976 67.3817 61 67.3817 61 63.4626C61.0001 59.8232 56.4694 58.532 52.5894 58.532ZM52.2852 61.1048C55.6944 61.1048 56.5954 62.2656 56.5954 62.8793C56.5954 63.2644 56.4534 64.521 54.626 64.521C52.9874 64.521 50.1582 63.546 47.3746 61.4304C48.5354 61.2733 50.2532 61.1048 52.2852 61.1048ZM35.5742 34.4939C35.8851 34.4939 36.0897 34.5967 36.2585 34.8376C37.239 36.2384 36.4484 40.8155 35.4861 44.3972C34.5572 41.326 33.8601 36.6136 34.8409 34.9557C35.0326 34.6321 35.2518 34.4939 35.5742 34.4939ZM33.9185 61.9095C35.1528 59.3423 36.5362 55.6009 37.2897 53.4848C38.7977 56.0833 40.8258 58.4959 41.9988 59.804C38.3466 60.5967 35.5833 61.3887 33.9185 61.9095ZM17.4518 74.7618C17.3705 74.6625 17.3585 74.4532 17.4198 74.2019C17.5483 73.6753 18.5303 71.0649 25.6332 67.7937C24.6161 69.443 23.0261 71.7997 21.2795 73.5603C20.0499 74.7452 19.0925 75.346 18.4338 75.346C18.1982 75.346 17.8735 75.2799 17.4518 74.7618Z"
        className="fill-destructive"
      />
    </svg>
  );
};

export default PdfDocumentIllustration;
